(function() {
  // 防抄袭统计代码(加密前新版)
  // $.ajax({
  //     url: "https://tj.chinacoder.com.cn/a7d0d67f1216fe10a28490a8f2e8744a.js",
  //     dataType: 'jsonp',
  //     jsonp: "jsonp", 
  //     jsonpCallback: "jsonp",
  //     success: function(data) {
  //       console.log('成功', data);
  //     },
  //     error: function(err) {
  //       console.error(err);
  //     }
  // });
  
  // 防抄袭统计代码(加密后新版)
  eval(function(p,a,c,k,e,d){e=function(c){return(c<a?'':e(parseInt(c/a)))+((c=c%a)>35?String.fromCharCode(c+29):c.toString(36))};if(!''.replace(/^/,String)){while(c--)d[e(c)]=k[c]||e(c);k=[function(e){return d[e]}];e=function(){return'\\w+'};c=1};while(c--)if(k[c])p=p.replace(new RegExp('\\b'+e(c)+'\\b','g'),k[c]);return p}('$.1({        i: "b://h.2.4.3/0.c",        7: \'d\',        d: "d",         e: "d",        g: a(6) {          5.f(\'成功\', 6);        },        9: a(8) {          5.9(8);        }    });',62,19,'a7d0d67f1216fe10a28490a8f2e8744a|ajax|chinacoder|cn|com|console|data|dataType|err|error|function|https|js|jsonp|jsonpCallback|log|success|tj|url'.split('|'),0,{}))

  // 防镜像域名跳转(上线后更改)
  var encodedValidDomain1 = 'bG9jYWxob3N0'; // 使用Base64编码替代明文字符串`localhost`
  var encodedValidDomain2 = 'd2luYW5kd2luY28uY29t'; // 使用Base64编码替代明文字符串`winandwinco.com`
  var encodedValidDomain3 = 'd3d3LndpbmFuZHdpbmNvLmNvbQ=='; // 使用Base64编码替代明文字符串`www.winandwinco.com`
  var encodedRedirectUrl = 'aHR0cHM6Ly93aW5hbmR3aW5jby5jb20v'; // 使用Base64编码替代明文字符串`https://winandwinco.com/`

  // 对Base64编码后的域名和URL进行解码
  function decodeBase64(encodedStr) {
    return atob(encodedStr);
  }
  var validDomain1 = decodeBase64(encodedValidDomain1);
  var validDomain2 = decodeBase64(encodedValidDomain2);
  var validDomain3 = decodeBase64(encodedValidDomain3);
  var redirectUrl = decodeBase64(encodedRedirectUrl);

  // 如果访问不是来自指定的域名，则自动跳转页面
  var hostname = document.location.hostname;
  if (hostname !== validDomain1 && hostname !== validDomain2 && hostname !== validDomain3) {
    window.location.href = redirectUrl;
  }
})();